import { useEffect } from 'react';

declare const Ya: any;

const YandexMetrica = () => {
    useEffect(() => {
        if (window.location.hostname === 'order.dry.care') {
            return;
        }

        (window as any).yaContextCb=(window as any).yaContextCb||[];

        const contextScript = document.createElement('script');
        contextScript.src = 'https://yandex.ru/ads/system/context.js';
        contextScript.async = true;
        document.head.appendChild(contextScript);

        (window as any).yaContextCb.push(() => {
            Ya.Context.AdvManager.render({
                'blockId': 'R-A-5985691-1',
                'type': 'floorAd',
                'platform': 'touch'
            });
        });

        return () => {
            document.head.removeChild(contextScript);
        };
    }, []);

    return null;
};

export default YandexMetrica;
